module.exports = __webpack_public_path__ + "img/logo.babb0f70.png";